import {ActionButton} from "../ActionButton";
import {CustomDialog} from "../../../components/DialogCustom";
import React from "react";

const generateIcon = (type: string) => {
  if (type === 'warning' || type === 'error') return 'fa-triangle-exclamation text-red-500'
  return 'fa-check-circle text-green-500'
}

interface TwoButtonDialogProps {
  type?: 'success' | 'warning' | 'error';
  title?: string;
  leftLabel: string;
  leftOnClick: () => void;
  leftIconName?: string;
  leftColor?: 'primary' | 'secondary' | 'warning';
  rightLabel?: string;
  rightOnClick?: () => void;
  rightIconName?: string;
  rightColor?: 'primary' | 'secondary' | 'warning';
}
export const TwoButtonDialog = ({
  type = 'success',
  title,
  leftLabel,
  leftOnClick,
  leftIconName = '',
  leftColor = 'primary',
  rightLabel = '',
  rightOnClick = () => null,
  rightIconName = '',
  rightColor = 'primary',
}: TwoButtonDialogProps) => (
  <CustomDialog>
    {/* icon */}
    <i className={`text-5xl fas ${generateIcon(type)}`} />

    {/* title */}
    {!!title && (
      <div className="text-lg font-semibold">
        {title.split(/\\n/).map((line, index) => (
          <div key={index} className="mb-1">
            {line}
          </div>
        ))}
      </div>
    )}

    <div className="flex flex-row gap-4">
      {/* button 1 */}
      <ActionButton
        fullWidth
        label={leftLabel}
        onClick={leftOnClick}
        iconName={leftIconName}
        color={leftColor}
      />

      {/* optional: button 2 */}
      {!!rightLabel &&
        <ActionButton
          fullWidth
          label={rightLabel}
          onClick={rightOnClick}
          iconName={rightIconName}
          color={rightColor}
        />
      }
    </div>
  </CustomDialog>
)